import type CurrencyCode from '@alltrails/types/CurrencyCode';
import { getPurchaseEventId, getTrialStartEventId, getSignupEventId } from './conversionsApi';

// https://business.reddithelp.com/s/article/manual-conversion-events-with-the-reddit-pixel
export const trackPurchaseForReddit = ({
  userId,
  currencyCode,
  value,
  isTrial,
  subscription_event_id
}: {
  userId: number;
  currencyCode: CurrencyCode;
  value: number;
  isTrial: boolean;
  subscription_event_id?: number;
}) => {
  if (isRedditPixelUnavailable() || !subscription_event_id) {
    return;
  }

  if (isTrial) {
    rdt('track', 'TrialStart', {
      conversionId: getTrialStartEventId(subscription_event_id),
      externalId: userId
    });
  } else {
    rdt('track', 'Purchase', {
      currency: currencyCode,
      value,
      conversionId: getPurchaseEventId(subscription_event_id),
      externalId: userId
    });
  }
};

export const trackCompleteRegistrationForReddit = (userId: number, currencyCode?: CurrencyCode | null) => {
  if (isRedditPixelUnavailable()) {
    return;
  }

  rdt('track', 'SignUp', { conversionId: getSignupEventId(userId), externalId: userId, currency: currencyCode || 'USD' });
};

// Check for presence of rdt in case of content blockers
const isRedditPixelUnavailable = () => {
  return typeof rdt === 'undefined';
};
